import { FaArrowLeft,FaArrowRight } from "react-icons/fa6";
import React, {  useState } from 'react';
import img from '../../assets/LandingImages/hero.png'
import useWindowSize from "./WindowSize";
import Carousel from "./SliderCarousel";
import MicroEventsCarousel from "./MicroEventsComponent";
import { MAIN_EVENT_DETAILS, MICRO_EVENTS_SECTION_DETAILS } from "../../lib/lib";
import { useCommonDataContext } from '../../context/CommonDataProvider';



function Events() {
    const [width, height] = useWindowSize()
    const [cardOffset,setCardOffset] = useState(0)
    const [numCards,setNumCards] = useState()
    if (width<1070 && numCards!==1) {
        setNumCards(1)
        setCardOffset(0)
    }
    else if (width<1605 && width>=1070 && numCards!==2) {
        setNumCards(2)
        setCardOffset(0)
    }
    else if (width>1605 && numCards!==3){
        setNumCards(3)
        setCardOffset(0)
    }

    const { microEventData } =
  useCommonDataContext();
    console.log('mircoeventsdata',microEventData)
   
    
   
    return (
        <>
            <div id="events" className="main-events px-2 md:px-40">
                <h1 className="heading">Main Events</h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 p-6">
                {MAIN_EVENT_DETAILS.map((event, index) => (
                    <MainCards key={index} event={event} />
                        ))}
                   
                </div>
            </div>
            <div className="micro-events">
                <h1 className="heading">Micro Events</h1>
                <div>
                   
                    <div className="overflow-x-hidden w-full"> 
      {/* <h1 className="text-center text-2xl mb-6">String Carousel</h1> */}
      <MicroEventsCarousel items={microEventData} interval={5000} />
    </div>

                    {/* <button onClick={() => arrowClick(numCards,(cardOffset+numCards)<len)} className={`right-button ${(cardOffset+numCards)<len && "active-button"} flex justify-center items-center`} ><FaArrowRight /></button> */}
                    
                </div>
            </div>
        </>
    )
}

function Micro(props) {
    return (
        <div className="roll-out card-micro flex flex-col gap-2" >
            <h1>{props.name}</h1>
            <p>{props.details} </p>
            <a href={props.link}>Learn More → </a>
        </div>
    )
}

function Main(props) {
    return (
        <div className="bg-red-300 flex ">
            <img alt={"props.data.title"}  src={props.data.img} width={200} height={200}></img>
            <div>
            <caption>{props.data.title}</caption>
            <p>{props.data.details}</p>
            </div>
        </div>
    )
}

function Dummy() {
    return (
        <div className="dummy"></div>
    )
}


function MainCards(props) {
  return (
    <div className="w-full sm:w-80 p-4 bg-white rounded-lg shadow-sm hover:shadow-md hover:border-2 hover:border-gray-200 transition-all duration-300 ease-in-out">
      {/* Event Image */}
      <div
        className="h-32 sm:h-40 w-full bg-cover rounded-md text-center overflow-hidden"
        style={{ backgroundImage: `url(${props.event.image})` }}
        title={props.event.title}
      ></div>

      {/* Event Details */}
      <div className="p-4 flex flex-col gap-3">
        <div>
          <div className="font-semibold text-xl text-gray-800 mb-2">{props.event.title}</div>
          <p className="text-gray-600 text-sm mb-2">{props.event.details}</p>

          {/* Additional Event Info */}
          <div className="text-gray-600 text-xs mb-1">
            <strong>Date:</strong> {props.event.date}
          </div>
          <div className="text-gray-600 text-xs mb-1">
            <strong>Time:</strong> {props.event.time}
          </div>
          <div className="text-gray-600 text-xs mb-2">
            <strong>Venue:</strong> {props.event.venue}
          </div>
        </div>

        {/* Read More Button */}
        <div className="flex items-center justify-start">
          <a
            href="/schedule"
            className="bg-gray-800 text-white px-2 py-2 rounded-md text-xs font-semibold hover:bg-gray-700 transition-all duration-200"
          >
            View schedule
          </a>
        </div>
      </div>
    </div>
  );
}
  
  

export default Events


